import { Editor, Element } from 'slate';

const hasMulipleBlocksSelected = (editor: Editor) => {
  const selectedBlocks = Array.from(
    Editor.nodes(editor, {
      match: (n) => !Editor.isEditor(n)
        && Element.isElement(n)
        && Editor.isBlock(editor, n)
        && ['list-item', 'paragraph'].includes(n.type),
    }),
  );
  return selectedBlocks.length > 1;
};

export default hasMulipleBlocksSelected;
